import { render } from "./MonetizeField.vue?vue&type=template&id=a93bb670"
import script from "./MonetizeField.vue?vue&type=script&lang=js"
export * from "./MonetizeField.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__